import { Affiliate } from '../translations-types';

const translations: Affiliate = {
  userDetails: 'Gebruiker Gegevens',
  bankDetails: 'Bankgegevens',
  swiftCode: 'Swift Code',
  iban: 'IBAN Nummer',
  bankName: 'Banknaam',
  country: 'Land',
  countryCode: 'Land Code',
  city: 'Plaatsnaam',
  postalCode: 'Postcode',
  streetAddress: 'Straatnaam Huisnr',
  recipientFullName: 'Ontvanger Volledige Naam',
  amount: 'Bedrag',
  agreeToAffiliates: 'Akkoord voor Affiliate',
  termsAndConditions: 'Voorwaarden & Condities',
  pleaseAgreeToTerms: 'Ik ben akkoord met de voorwaarden & condities',
  resenceReferralProgram: 'Re-sence Referral Programma',
  login: 'Log in',
  signIn: 'Aanmelden',
  signOut: 'Afmelden',
  forgotPassword: 'Paswoord vergeten',
  commission: 'Comissie',
  commissions: 'Commissies',
  status: 'Status',
  confirmed: 'Bevestigd',
  completed: 'Voltooid',
  pending: 'Bezig',
  affiliateUser: 'Affiliate gebruiker',
  accumulatedCommission: 'Verzamelde Commissie',
  withdrawTooltip: 'Om te kunnen opnemen hebben we je bankgegevens nodig in je profiel',
  withdraw: 'Opnemen',
  withdrawCommissions: 'Commissie opnemen',
  withdrawals5Days: 'Opnames worden binnenkort 5 werkdagen verwerkt',
  earnings: 'Verdiensten',
  faqTitle: 'FAQ over Aanbevelen en Verdiensten',
  totalCommission: 'Totale Commissie',
  totalRecommendations: 'Totale Aanbevelingen',
  myWithdrawals: 'Mijn Opnames',
  editCode: 'Wijzig  Affiliate Code',
  ifYouChangeLink: 'Als je de link wijzigd zal de oude link niet meer werken.',
  codeValidation: '6-15 karakters. Alleen letters en cijfers',
  code: 'Code',
  linkCopied: 'Link Succesvol gekopieerd',
  codeCopied: 'Kortingscode Succesvol gekopieerd',
  inviteTitle: 'Uitnodigen schoonheidsspecialist, Verdien Commissie!',
  copyLink: 'Kopieëren Link',
  copyDiscountCode: 'Kopieëren Kortingscode',
  referResence: ' Re-sence aanbevelen aan een vriend',
  profileSettings: 'Profiel instellingen',
  navigationInvite: 'Uitnodigen',
  navigationCommissions: 'Commissies',
  navigationEarnings: 'Verdiensten',
};

export default translations;
